import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContenedorBoton, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import global_axios from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_ChequesporCliente } from '../../actions/clientes/act_cli02';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarCampoString, validarPermisoAcceso, validarFechaTransaccionSeleccionada, validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import styled from 'styled-components';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';

const LabelCheques = styled.label`
  display: inline-block;
  font-size: 12px;
  padding-top: 15px;
  font-style: italic;
`;

class FormCli09 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'G',
      fechaCanje: null,
      cliente_sel: null,
      cheques: [],
      observacion: '',

      columnsDefGridCheques: [
        { header: "",
          width: 35,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          pinned: true
        },
        { header: "No.",
          field: "Secuencia",
          width: 35,
          type: "string",
          suppressFilter: true
        },
        {
          header: "Banco",
          field: "Banco",
          width: 160,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 100,
          type: "string"
        },
        { header: "Cheque",
          field: "Cheque",
          width: 80,
          type: "string"
        },
        { header: "Valor",
          field: "Valor",
          width: 80,
          type: "num_decimal",
          filter: "number"
        },
        { header: "Estado",
          field: "Estado",
          width: 60,
          type: "string",
          suppressFilter: true,
          suppressSorting: true
        },
        { header: "Factura",
          field: "Factura",
          width: 100,
          type: "string",
          suppressSorting: true
        },
        { header: "Fecha",
          field: "FechaCheque",
          width: 90,
          type: "string"
        },
        { header: "F. Venc.",
          field: "FecVencimiento",
          width: 90,
          type: "string"
        },
        { header: "Saldo",
          field: "Saldo",
          width: 80,
          type: "num_decimal",
          filter: "number"
        },
        { header: "Caja",
          field: "Caja",
          width: 55,
          type: "string",
          suppressFilter: true,
          suppressSorting: true
        },
        { header: "Mov. Caja",
          field: "Movimiento",
          width: 90,
          type: "string"
        }
      ]
    };
    
    this.gridChequesOptions = {
      enableColResize: true,
      enableFilter: true,
      enableSorting: true
    };
    
    this.onGridChequesReady = this.onGridDetChequesReady.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.getOptions_Clientes = this.getOptions_Clientes.bind(this);    
    this.cargarChequesPorCliente = this.cargarChequesPorCliente.bind(this);
    this.procesarCanjeCheque = this.procesarCanjeCheque.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  onGridDetChequesReady(params) {
    this.apiGridCheques = params.api;
    this.columnApiGridCheques = params.columnApi;
  }
  
  componentDidMount(){
    this.props.generar_LogAuditoriaIngresoForm('0109');
    let fechaProceso = getFechaProcesoPorModulo('01');
    this.setState({ fechaCanje: moment(fechaProceso, 'DD/MM/YYYY') });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0109');
  }  

  cargarChequesPorCliente(){
    let clienteId = this.state.cliente_sel.value;
    if (!validarCampoString(clienteId, 7)){
      alert('Debe seleccionar el cliente del cual desea consultar los cheques.');
      return;
    }
    else{    
      this.props.cargar_ChequesporCliente(clienteId, 'P')
      .then(()=>{
          try {
            if (this.props.cheques.length>0){
              let cheques = [];
              this.props.cheques.forEach((cheque, i) => {
                cheques.push({
                    Secuencia: (i+1),
                    Banco: `${cheque.banco.Codigo} - ${cheque.banco.Descripcion}`,
                    Cuenta: cheque.Cuenta,
                    Cheque: cheque.Cheque,
                    Valor: cheque.Valor,
                    Estado: cheque.Status,
                    Factura: cheque.Factura,
                    FechaCheque: cheque.FechaCheque,
                    FecVencimiento: cheque.Vencimiento,
                    Saldo: cheque.Saldo,
                    Caja: cheque.Caja,
                    Movimiento: cheque.Movimiento                
                });
              });
              this.setState({cheques});
            }else{
              alert('No existen cheques postfechados para el cliente seleccionado.');
            }
          } catch (error) {
            alert(`Ha ocurrido un error al cargar los cheques. Error: ${error}`);
          }
      });
    }
  }

  limpiar(){
    let fechaProceso = getFechaProcesoPorModulo('01');
    this.setState({
      fechaCanje: moment(fechaProceso, 'DD/MM/YYYY'),
      cliente_sel: null,
      cheques: [],
      observacion: ''
    });
  }

  procesarCanjeCheque(){
    try{
      let fechaProceso = getFechaProcesoPorModulo('01');

      let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
      if (!validPermiso.esValido){
        alert(validPermiso.msg);
        return;
      }

      if(this.state.cliente_sel === null){
        alert('No ha especificado un cliente.');
        return;
      }

      if ((this.state.cheques.length===0) || (this.apiGridCheques.getSelectedRows().length === 0)){
        alert('No ha seleccionado el cheque que va a canjear.');
        return;
      }
      
      let chequeSelecc = this.apiGridCheques.getSelectedRows()[0];

      let fechaCanje = formatearFechaMoment_a_String(this.state.fechaCanje);
      if (!validarFechaMomentEnFormatoString(fechaCanje)){
        alert('La Fecha de Canje es inválida.');
        return;
      }

      if(this.state.observacion.trim().length === 0){
        alert('No ha especificado una observación.');
        return;
      }

      if (this.props.permiteCambioFProceso==='S'){
        let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaCanje, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
        
        if(!validFProceso.esValida){
            alert(validFProceso.msg);
            return;
        }
      }
          
      let canjeCheque = {
        fechaCanje: formatearFechaMoment_a_String(this.state.fechaCanje),       
        observacion: this.state.observacion,
        usuario: getItemDatosSesion('usuario').toString(),
        moneda:  JSON.parse(getItemDatosSesion('moneda')).Moneda,
        dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
        idRegAudit: this.props.idRegAudit
      }
          
      this.props.cambiar_VisualizacionLoading(true);

      let url = `/chequescliente/${this.state.cliente_sel.value}/${chequeSelecc.Banco.trim().substr(0,2)}/${chequeSelecc.Cuenta}`;
      url += `/${chequeSelecc.Cheque}/canjes`;

      global_axios({
        method: 'POST',
        url,
        data: canjeCheque
      })
      .then((response)=>{
        this.props.cambiar_VisualizacionLoading(false);
        alert(`Se registró correctamente el canje del cheque seleccionado. Nota de Débito generada: ${response.data.notaDebitoGenerada}`);
        this.limpiar();
      })
      .catch(error => {
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      });
    }catch(error){
      alert(`Ocurrió un error al procesar el registro de canje del cheque seleccionado. Error: ${error}`);
    }
  }

  render(){
    return(
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Canje de Cheques</TituloForm>
        </HeaderForm>
        <CuerpoForm>
          <Row>
            <ContainerCol className='col-sm-4'>
              <LabelForm>Cliente:</LabelForm>
              <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes}
                func_onChange={(value)=>{ if(Array.isArray(value)){value=null}; this.limpiar(); this.setState({cliente_sel: value})} }/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <ContenedorBoton margen_arriba={20}>
                <Tooltip placement='right' overlay='Buscar cheques postfechados del cliente seleccionado.'>
                  <button type='button' className='btn btn-success btn-sm' onClick={this.cargarChequesPorCliente}><i className='fa fa-search'></i></button>
                </Tooltip>
              </ContenedorBoton>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12'><LabelCheques>Cheques postfechados:</LabelCheques></ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12'>
            <AgGridRender altura='300px' data={this.state.cheques} columnas={this.state.columnsDefGridCheques}
              gridOptions={this.gridChequesOptions} onGridReady={this.onGridChequesReady}/>
            </ContainerCol>
          </Row>
          <Row>            
            <ContainerCol className='col-sm-2'>
              <LabelForm>Fecha de Canje:</LabelForm>
              <PickerFecha fechaSeleccionada={this.state.fechaCanje} disabled={!(this.props.permiteCambioFProceso==='S')}
                func_onChange={(fecha)=>{this.setState({fechaCanje: fecha})}}/>
            </ContainerCol>                    
            <ContainerCol className='col-sm-6'>
              <LabelForm>Observación:</LabelForm>
              <InputText autoComplete='off' name='observacion' value={this.state.observacion} type='text' className='form-control input-sm' placeholder='Observación'
                onChange={this.handleInputChange}/>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12' margen_arriba={15}>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.procesarCanjeCheque}><i className='fa fa-floppy-o fa-lg'/> Registrar Canje</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
              </div>
            </ContainerCol>
          </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }  
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            cheques: state.clientes.cheques,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading,
                              cargar_ChequesporCliente }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli09);